(function () {
  'use strict';

  var section = document.getElementById('CollectionSection');
  if (!section) return;

  var grid = document.getElementById('collection-grid');
  var navList = document.getElementById('collection-navigation-list');
  var sentinel = document.getElementById('infinite-scroll-sentinel');
  var loader = document.getElementById('infinite-scroll-loader');
  if (!grid || !sentinel) return;

  var collectionUrl = section.getAttribute('data-collection-url');
  var sectionId = section.getAttribute('data-section-id');
  var totalPages = parseInt(sentinel.getAttribute('data-total-pages'), 10) || 1;

  var loadedPages = {};
  var loadingPromise = null;
  var nextBatchToReveal = 2; // page 1 is already visible on load
  var allProducts = [];

  // ---- Parse page 1's own embedded data (already in the DOM) ----
  function parsePageJson(pageNum) {
    var script = document.querySelector('script[data-collection-page-json][data-batch="' + pageNum + '"]');
    if (!script) return;
    try {
      var data = JSON.parse(script.textContent);
      allProducts = allProducts.concat(data);
    } catch (e) {
      console.error('collection-infinite: JSON parse error page', pageNum, e);
    }
  }
  parsePageJson(1);
  loadedPages[1] = true;

  // ---- Card interaction re-init (mirrors product-card.liquid inline scripts) ----
  function initCardInteractions(container) {
    var cards = container.querySelectorAll('.product-card');
    cards.forEach(function (card) {
      var handle = card.id;
      if (!handle || card.dataset.interactionsBound) return;
      card.dataset.interactionsBound = '1';

      var options = card.querySelectorAll('.quick-shop__option-color, .product-card__swatch');
      options.forEach(function (option) {
        ['mouseenter', 'click', 'touchstart'].forEach(function (eventType) {
          option.addEventListener(eventType, function (event) {
            event.preventDefault();
            var color = event.currentTarget.dataset.backgroundColor || event.currentTarget.dataset.color;
            var images = card.querySelectorAll('.image_quickview');
            images.forEach(function (img) {
              img.style.opacity = (img.dataset.color === color) ? '1' : '0';
            });
            var swatches = card.querySelectorAll('.product-card__swatch');
            swatches.forEach(function (s) { s.style.outline = 'none'; });
            if (event.currentTarget.classList.contains('product-card__swatch')) {
              event.currentTarget.style.outline = '2px solid #000';
              event.currentTarget.style.outlineOffset = '2px';
            }
          });
        });
      });

      var altOptions = card.querySelectorAll('.product-card__swatch-alt');
      altOptions.forEach(function (option) {
        option.addEventListener('mouseenter', function (event) {
          var color = event.currentTarget.dataset.color;
          var images = card.querySelectorAll('.image_quickview');
          images.forEach(function (img) {
            img.style.opacity = (img.dataset.color === color) ? '1' : '0';
          });
        });
      });
    });
  }
  initCardInteractions(grid);

  // ---- Fetch and merge one page ----
  function fetchPage(pageNum) {
    if (loadedPages[pageNum]) return Promise.resolve();
    var sep = collectionUrl.indexOf('?') > -1 ? '&' : '?';
    var url = collectionUrl + sep + 'page=' + pageNum + '&section_id=' + encodeURIComponent(sectionId);

    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // Cards: append hidden, tagged with their batch number
        var newCards = doc.querySelectorAll('#collection-grid .product-card');
        var frag = document.createDocumentFragment();
        newCards.forEach(function (card) {
          card.classList.add('is-pending-reveal');
          card.setAttribute('data-batch', pageNum);
          frag.appendChild(card);
        });
        grid.appendChild(frag);
        initCardInteractions(grid);

        // Nav: append any collection_key / handle not already present
        var newNavItems = doc.querySelectorAll('#collection-navigation-list li');
        newNavItems.forEach(function (li) {
          var key = li.getAttribute('data-collection-key');
          var handle = li.getAttribute('data-handle');
          var existsSelector = key
            ? '[data-collection-key="' + CSS.escape(key) + '"]'
            : '[data-handle="' + CSS.escape(handle) + '"]';
          if (!navList.querySelector(existsSelector)) {
            navList.appendChild(li);
          }
        });

        // Product/variant JSON for filters
        var jsonScript = doc.querySelector('script[data-collection-page-json]');
        if (jsonScript) {
          try {
            var data = JSON.parse(jsonScript.textContent);
            allProducts = allProducts.concat(data);
          } catch (e) {
            console.error('collection-infinite: JSON parse error fetched page', pageNum, e);
          }
        }

        loadedPages[pageNum] = true;
      });
  }

  // ---- Background: load every remaining page, a few at a time ----
  function ensureAllPagesLoaded() {
    if (loadingPromise) return loadingPromise;

    var pagesToLoad = [];
    for (var p = 2; p <= totalPages; p++) {
      if (!loadedPages[p]) pagesToLoad.push(p);
    }
    if (pagesToLoad.length === 0) {
      loadingPromise = Promise.resolve();
      return loadingPromise;
    }

    var concurrency = 3;
    var index = 0;
    function worker() {
      if (index >= pagesToLoad.length) return Promise.resolve();
      var page = pagesToLoad[index++];
      return fetchPage(page).then(worker);
    }
    var workers = [];
    for (var i = 0; i < concurrency; i++) workers.push(worker());

    loadingPromise = Promise.all(workers);
    return loadingPromise;
  }

  // Kick off background loading immediately, not gated on scroll
  ensureAllPagesLoaded();

  // ---- Scroll reveal: show the next hidden batch when sentinel is visible ----
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealNextBatch();
    });
  }, { rootMargin: '400px 0px' });
  observer.observe(sentinel);

  function revealNextBatch() {
    var pending = document.querySelectorAll('.is-pending-reveal[data-batch="' + nextBatchToReveal + '"]');
    if (pending.length === 0) {
      // Batch not fetched yet — show loader, retry shortly
      if (nextBatchToReveal <= totalPages) {
        if (loader) loader.classList.add('is-active');
        setTimeout(revealNextBatch, 300);
      }
      return;
    }
    pending.forEach(function (card) { card.classList.remove('is-pending-reveal'); });
    if (loader) loader.classList.remove('is-active');
    nextBatchToReveal++;
    if (nextBatchToReveal > totalPages) observer.disconnect();
  }

  // ---- Exposed API for collection-filters.liquid ----
  window.__collectionInfinite = {
    ensureAllPagesLoaded: ensureAllPagesLoaded,
    getAllProducts: function () { return allProducts; },
    revealAllCards: function () {
      document.querySelectorAll('.is-pending-reveal').forEach(function (card) {
        card.classList.add('is-filter-revealed');
        card.classList.remove('is-pending-reveal');
      });
    },
    restoreScrollReveal: function () {
      document.querySelectorAll('.is-filter-revealed').forEach(function (card) {
        var batch = parseInt(card.getAttribute('data-batch'), 10) || 1;
        if (batch >= nextBatchToReveal) {
          card.classList.add('is-pending-reveal');
        }
        card.classList.remove('is-filter-revealed');
      });
    }
  };
})();
